import * as React from 'react';
import { UIText1, ModalWindow } from '@cian/ui-kit';
import { IconSuccess16, IconSort24 } from '@cian/ui-kit/icons';

import * as styles from './SortingMobile.css';
import { ISortingProps } from '../../types';

export const SortingMobile: React.FC<ISortingProps> = ({ disabled, onChange, options, selectedOption }) => {
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const toggleOpenModal = React.useCallback(() => setIsOpenModal(prev => !prev), []);

  const handleSelectOption = React.useCallback(
    (event: React.MouseEvent) => {
      const index = Number(event.currentTarget.getAttribute('data-index'));
      const nextOption = options[index];

      if (!selectedOption || nextOption.value !== selectedOption.value) {
        onChange(nextOption);
      }

      setIsOpenModal(false);
    },
    [onChange, selectedOption, options],
  );

  return (
    <>
      <button
        className={styles['sort-button']}
        onClick={toggleOpenModal}
        disabled={disabled}
        type="button"
        aria-label="Сортировка"
      >
        <IconSort24 color="primary_100" />
      </button>
      <ModalWindow title="Сначала показывать" size="XS" open={isOpenModal} onClose={toggleOpenModal} maxWidth={400}>
        <div className={styles['modal-content']}>
          <ul className={styles['options-list']} role="listbox">
            {options.map((option, idx) => {
              const isSelected = (selectedOption && option.value === selectedOption.value) || false;

              return (
                <li
                  className={styles['option']}
                  role="option"
                  aria-checked={isSelected}
                  key={option.value}
                  data-index={idx}
                  data-value={option.value}
                  onClick={handleSelectOption}
                >
                  <UIText1>{option.label}</UIText1>
                  <span className={styles['check']}>{isSelected && <IconSuccess16 color="primary_100" />}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </ModalWindow>
    </>
  );
};
